const legacySoundNames = [
    'ding',
    'outbid',
    'highest',
    'congrats',
    'onetime',
    'twice',
    'three',
    'lotopen',
    'lotsold',
]

function getSound(name) {
    return window[name] || null
}

export function setLegacySoundsMuted(muted) {
    legacySoundNames.forEach(name => {
        const sound = getSound(name)

        if (!sound) {
            return
        }

        sound.stop()
        sound.mute(muted)
    })
}

export function playLegacySound(name) {
    const sound = getSound(name)

    if (!sound) {
        return null
    }

    sound.stop()

    return {
        sound,
        id: sound.play(),
    }
}

export function stopLegacyPlayback(playback) {
    if (!playback || !playback.sound) {
        return
    }

    playback.sound.stop(playback.id)
}
